module.exports = __webpack_public_path__ + "img/pattern.41360df1.png";